import { IRoute, Routes } from './route';

// menu
export const RouteMenus: IRoute[] = [Routes.HOME, Routes.THONG_TIN_CA_NHAN, Routes.CHAM_CONG];
